import React from "react";

const TwoCards: React.FC<{ onOpenModal: () => void }> = ({ onOpenModal }) => {
  return (
    <div>
      <div className="w-full py-10 flex justify-center items-center px-7 md:px-5 lg:px-20">
        <div className="grid md:grid-cols-2 gap-16 xl:px-32">
          <ContactUS onOpenModal={onOpenModal} />
          <EnrollNow onOpenModal={onOpenModal} />
        </div>
      </div>
    </div>
  );
};

const ContactUS: React.FC<{ onOpenModal: () => void }> = ({ onOpenModal }) => {
  return (
    <div className="shadow-2xl">
      <div>
        <img
          src="/consulting/organization.jpg"
          alt=""
          className="w-full max-h-80 object-cover object-center"
        />
      </div>
      <div className="p-10 py-6 flex flex-col gap-2">
        <p className="text-xl font-bold  xl:text-[1.8rem]">
          For Your Organization
        </p>
        <p className="font-normal text-lg xl:text-3xl pt-1">
          Empower Your Workforce with Tailored Training Solutions
        </p>
        <p className="text-xs py-3 xl:text-[0.96rem] leading-normal font-medium">
          Unlock the full potential of your employees with Dream Weavers’
          expert-led training programs. Whether you need to upskill teams or
          ensure compliance, we offer customized solutions to meet your
          organizational goals.
        </p>
        <p className="font-bold text-sm xl:text-[1rem] pt-2">What We Offer</p>
        <div className="flex flex-col gap-1 mx-2 text-[#090808]">
          <div className="flex gap-1 text-xs xl:text-base">
            <div>&#x2022;</div>
            <p>
              Domain Training: Enhance technical expertise for industry-specific
              needs.
            </p>
          </div>
          <div className="flex gap-1 text-xs xl:text-base">
            <div>&#x2022;</div>
            <p>
              Compliance Training: Equip your team with up-to-date regulatory
              knowledge.
            </p>
          </div>
          <div className="flex gap-1 text-xs xl:text-base">
            <div>&#x2022;</div>
            <p>
              Leadership Development: Foster visionary and effective leaders.
            </p>
          </div>
          <div className="flex gap-1 text-xs xl:text-base">
            <div>&#x2022;</div>
            <p>
              Soft Skills Training: Strengthen communication and interpersonal
              abilities.
            </p>
          </div>
        </div>
        <div className="py-6">
          <div
            className="text-xs  md:text-sm xl:text-2xl"
            onClick={onOpenModal}
          >
            <button className="px-5 py-3 custom-hover rounded-full  text-white bg-[#0040D8]">
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const EnrollNow: React.FC<{ onOpenModal: () => void }> = ({ onOpenModal }) => {
  return (
    <div className="shadow-2xl">
      <div>
        <img
          src="/consulting/professional.jpg"
          alt=""
          className="max-h-80 w-full bg-center"
        />
      </div>
      <div className="p-10 py-6 flex flex-col gap-2">
        <p className="text-xl font-bold  xl:text-[1.8rem]">For Yourself</p>
        <p className="font-normal text-lg xl:text-3xl pt-1">
          Invest in Your Skills and Accelerate Your Career
        </p>
        <p className="text-xs py-3 xl:text-[0.96rem] leading-normal font-medium">
          Take charge of your growth with specialized training programs designed
          for career advancement. Join the league of professionals excelling in
          their industries with Dream Weavers’ expert guidance.
        </p>
        <p className="font-bold text-sm xl:text-[1rem] pt-2 md:pt-8">
          Why Join Us?
        </p>
        <div className="flex flex-col gap-1 mx-2 text-[#090808]">
          <div className="flex gap-1 text-xs xl:text-base">
            <div>&#x2022;</div>
            <p>
              Industry-Specific Training: Master the skills required for your
              chosen field.
            </p>
          </div>
          <div className="flex gap-1 text-xs xl:text-base">
            <div>&#x2022;</div>
            <p>
              Compliance Readiness: Gain critical knowledge of workplace
              regulations.
            </p>
          </div>
          <div className="flex gap-1 text-xs xl:text-base">
            <div>&#x2022;</div>
            <p>
              Leadership Skills: Build confidence to lead teams effectively.
            </p>
          </div>
          <div className="flex gap-1 text-xs xl:text-base">
            <div>&#x2022;</div>
            <p>
              Soft Skills Excellence: Improve communication and interpersonal
              skills.
            </p>
          </div>
        </div>
        <div className="py-6">
          <div className="text-xs md:text-sm xl:text-xl" onClick={onOpenModal}>
            <button className="px-5 py-3 custom-hover rounded-full  text-white bg-[#0040D8]">
              Recommend us to your organization
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TwoCards;
